<template>
	<v-dialog v-model="dialogOpened" persistent :content-class="isMobileChannel ? 'upgrade-deal-to-menu-dialog kiosk-modal' : 'upgrade-deal-to-menu-dialog upgrade-deal-to-menu-dialog-desktop kiosk-modal'">
		<v-card class="upgrade-deal-to-menu-dialog-body">
			<div class="upgrade-deal-to-menu-close-btn">
				<v-btn icon @click="onClose" class="close-btn">
					<img class="close-image" src="../../../../../static/tid100/images/icons/x-close.svg"/>
				</v-btn>
			</div>
			<div></div>
			<v-flex column class="upgrade-deal-to-menu-main-part">
				<v-flex class="upgrade-deal-to-menu-icon">
					<v-img :src="getImage('deals-upgrade-icon.svg')"></v-img>
				</v-flex>
				<v-card-text>
					<v-flex class="upgrade-deal-to-menu-dialog-title">
						{{ header }}
					</v-flex>
					<v-flex class="upgrade-deal-to-menu-dialog-subtitle">
						{{ text }}
					</v-flex>
					<v-flex class="upgrade-deal-to-menu-dialog-question">
						{{ question }}
					</v-flex>
					<v-flex class="upgrade-deal-to-menu-dialog-question">
						{{ additionalText }}
					</v-flex>
				</v-card-text>
			</v-flex>
			<v-flex flex class="upgrade-deal-to-menu-dialog-footer">
				<v-btn class="green-btn" @click="onConfirm">
					{{$t('shopComponents.gt2.shoppingCart_steps.shoppingCartStepCheckoutInit.deals.yes')}}
				</v-btn>
				<v-btn class="transparent-btn btn-transparent" @click="onClose">
					{{$t('shopComponents.gt2.shoppingCart_steps.shoppingCartStepCheckoutInit.deals.no')}}
				</v-btn>
			</v-flex>
		</v-card>
	</v-dialog>

</template>
<script>
import * as Utils from "../../../../libraries/utils";
import appConfig, {channelEnum} from "../../../../appconfig";

export default {
	name: "UpgradeDealToMenuDialog",
	props: ["header", "text", "question", "additionalText", "onConfirm", "onClose", "dialogOpened"],
	computed: {
		isMobileChannel() {
			return appConfig.channelAlias() === channelEnum.mobileBrowser || appConfig.channelAlias() === channelEnum.mobileApp;
		}
	},
	methods: {
		getImage(imageName) {
			return Utils.getMiscImageUrl(imageName);
		}
	}
};
</script>
<style scoped lang="scss">
/deep/ .v-dialog.upgrade-deal-to-menu-dialog {
	height: 100vh;
	max-height: 100%;
	background-color: #000000;
	.upgrade-deal-to-menu-close-btn {
		display: flex;
		justify-content: flex-end;
		img {
			width: 17px;
			position: unset;
		}
	}
	.upgrade-deal-to-menu-dialog-body {
		background-color: #000000;
		color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
		flex: 0 1 auto;
		.upgrade-deal-to-menu-icon {
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #218C74;
			width: 100px;
			height: 100px;
			margin: auto;
			border-radius: 50%;
			.v-image {
				flex: 0 1 auto;
				width: 52px;
				height: 52px;
			}
		}
		.upgrade-deal-to-menu-dialog-title {
			font-size: 18px;
			text-transform: uppercase;
			text-align: center;
			margin: 50px 0 16px 0;
			font-weight: 700;
		}
		.upgrade-deal-to-menu-dialog-subtitle {
			text-align: center;
			margin: 16px 0;
		}
		.green-text {
			color: #218C74;
		}
		.upgrade-deal-to-menu-main-part, .upgrade-deal-to-menu-dialog-footer {
			display: flex;
			flex: 0 1 auto;
			padding: 16px;
		}
		.upgrade-deal-to-menu-dialog-footer {
			flex-wrap: wrap;
			gap: 16px;
		}
		.upgrade-deal-to-menu-main-part {
			flex-direction: column;
		}
	}
	&.upgrade-deal-to-menu-dialog-desktop {
		margin: auto;
		height: fit-content;
		.upgrade-deal-to-menu-dialog-footer {
			flex-wrap: nowrap;
			.green-btn, .btn-transparent {
				width: 49%;
				height: 50px;
				margin: 0;
			}
		}
		.upgrade-deal-to-menu-close-btn {
			position: absolute;
			right: -14px;
			top: -20px;
			width: 45px;
			height: 45px;
			background-color: #000000;
			border: 2px solid #202020;
			margin: -22px;
			border-radius: 50%;
			justify-content: center;
			align-items: center;
			.v-btn.close-btn {
				top: unset;
				right: unset;
			}
		}
	}
}
</style>
